import * as core from '../../../../../../../core'
import * as prebuilt from '../../../../../../prebuilt'
import * as rate from '../rate'

const page = prebuilt.Page.get(prebuilt.Page.Id.RateGl)

export const RESOURCE = {
  payload: {
    alias: 'gl',
    appAlias: rate.RESOURCE.payload.alias,
    description: page.description,
    display: {
      isMain: true,
      position: 1,
    },
    name: 'GL',
    page: { id: prebuilt.Page.Id.RateGl },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
